import React from 'react'
import { Smartphone, Check } from 'lucide-react'

interface MobileDeviceStatusProps {
  mobileCameraStream: MediaStream | null | undefined;
  workspaceDetected: boolean;
  handsDetected: boolean;
}

const MobileDeviceStatus: React.FC<MobileDeviceStatusProps> = ({
  mobileCameraStream,
  workspaceDetected,
  handsDetected,
}) => {
  if (!mobileCameraStream) return null;

  return (
    <div className="flex items-center gap-3 px-3 py-1.5 bg-black/40 backdrop-blur-md rounded-full border border-white/10">
      <div className="flex items-center gap-1.5">
        <Check
          className={`shrink-0 h-3 w-3 ${
            workspaceDetected ? 'text-emerald-400' : 'text-slate-400/60'
          }`}
        />
        <span className={`text-[10px] font-semibold tracking-tight ${
          workspaceDetected ? 'text-white' : 'text-white/40'
        }`}>
          Laptop
        </span>
      </div>

      <div className="w-px h-2.5 bg-white/10" />

      <div className="flex items-center gap-1.5">
        <Check
          className={`shrink-0 h-3 w-3 ${
            handsDetected ? 'text-emerald-400' : 'text-slate-400/60'
          }`}
        />
        <span className={`text-[10px] font-semibold tracking-tight ${
          handsDetected ? 'text-white' : 'text-white/40'
        }`}>
          Hands
        </span>
      </div>

      <div className="w-px h-2.5 bg-white/10" />

      <div className="flex items-center gap-1.5">
        <Check className="shrink-0 h-3 w-3 text-emerald-400" />
        <span className="text-[10px] font-semibold tracking-tight text-white">
          Battery
        </span>
      </div>
    </div>
  );
};

export default MobileDeviceStatus;


